<template>
  <px-custom-dialog transition="fadet"
                      width="900"
                      v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <px-resposta-negociacao :resposta="resposta" :dialog="dialog"/>
  </px-custom-dialog>
</template>
<script>
import RespostaNegociacao from '../RespostaNegociacao.vue';

export default {
  props: {
    resposta: Object,
  },
  data() {
    return {
      dialog: false,
    };
  },
  components: {
    PxRespostaNegociacao: RespostaNegociacao,
  },
};
</script>
